import { Component, OnInit,ViewChild } from '@angular/core';
import { FormControl, Validators, FormGroup } from '@angular/forms';
import { AuthService } from '../../services-http/auth/auth.service';
import { SweetAlertService } from '../../services-components/sweet-alert/sweet-alert.service';
import { Router } from '@angular/router';
import { ModalDirective} from 'ng-uikit-pro-standard';
import { NgxSpinnerService } from 'ngx-spinner';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-welcome-home',
  templateUrl: './welcome-home.component.html',
  styleUrls: ['./welcome-home.component.scss']
})
export class WelcomeHomeComponent implements OnInit {
  @ViewChild('basicModal') basicModal: ModalDirective;
  @ViewChild('basicModalReg') basicModalReg: ModalDirective;
  dialogIndex:any=0;

  users = JSON.parse(localStorage.getItem('currentUser'));

  // user = {};
  showPassword:boolean=false;

  redirect = false;
  recoveryEmail:any = new FormControl();
  usertype:any = new FormControl();
  replyOTP;
  OTP:number;
  lackform:any = "";
  searchListShow:boolean = false;
  coopInfo
  searchText:any;
  searchResult:any = [];
  searchitems:any={};
  optionsSelect:any = [];
  carousel:any=[];
  signUpNav:boolean=false;

 

  agentSelect = [
    { value: '1', label: 'CAC Agent/branch' },
    { value: '2', label: 'GAM Agent/branch' },
    { value: '4', label: 'Regular Coop Agent/branch' }
  ];

  createNewPasswordForm = new FormGroup({
    email: new FormControl(''),
    newPassword: new FormControl(''),
    confirmPassword: new FormControl(''),
    code: new FormControl(''),
  });

  loginForm = new FormGroup({
    username: new FormControl(''),
    password: new FormControl(''),
  });


  validatingForm = new FormGroup({
    formRegisterCode               : new FormControl('', [Validators.required, Validators.pattern("^[0-9]*$")]),
    formRegisterUserType           : new FormControl('', [Validators.required]),
    formRegisterAgentType          : new FormControl(''),
    formRegisterMobileNum          : new FormControl('', [Validators.required, Validators.pattern("^[0-9]*$"), Validators.minLength(11), Validators.maxLength(11)] ),
    formRegisterAddress            : new FormControl('', [Validators.required]),
    formCompleteName               : new FormControl('', [Validators.required]),
    formFirstname                  : new FormControl('', [Validators.required]),
    formMiddlename                 : new FormControl('', [Validators.required]),
    formLastname                   : new FormControl('', [Validators.required]),
    formRegisterEmail              : new FormControl('', [Validators.required, Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$")] ),
    formRegisterNewPassword        : new FormControl('', [Validators.required]),
    formRegisterConfirmNewPassword : new FormControl('', [Validators.required]),
    privacy                        : new FormControl(0),
    coop_branch                    : new FormControl('')
  });

 
  constructor(
    private authService: AuthService,
    private sweetAlertService: SweetAlertService,
    private router: Router,
    private spinner: NgxSpinnerService,

  ) { }


  ngOnInit() { }


  async login() {
    await this.authService.login(this.loginForm.value)
    .subscribe(
      (data:any) => {
        console.log(data);

        this.spinner.hide();
        if(data['is_profile_updated'] == null){
          this.router.navigateByUrl('/welcome/update-profile');
        } else if (data['usertype'] == '1') {
          this.router.navigateByUrl('/admin/homepage');
        } else if (data['usertype'] == '3') {
          this.router.navigateByUrl('/gam/homepage');
        } else if (data['usertype'] == '4') {
          this.router.navigateByUrl('/cac/homepage');
        } else if (data['usertype'] == '5') {
          this.router.navigateByUrl('/agent/homepage');
        } else if (data['usertype'] == '6') {
          this.router.navigateByUrl('/coop/homepage');
        } else if (data['usertype'] == '7') {
          this.router.navigateByUrl('/endorsement-officer/homepage');
        } else if (data['usertype'] == '8') {
          this.router.navigateByUrl('/DQC-officer/homepage');
        } else if (data['usertype'] == '9') {
          this.router.navigateByUrl('/quotation-approval-officer/homepage');
        } else if (data['usertype'] == '10') {
          this.router.navigateByUrl('/cashin-approval-officer/homepage');
        } else if (data['usertype'] == '11') {
          this.router.navigateByUrl('/claims-officer/homepage');
        } else if (data['usertype'] == '12') {
          this.router.navigateByUrl('/user-management-officer/homepage');
        } else if (data['usertype'] == '13') {
          this.router.navigateByUrl('/renewalOfficer/homepage');
        } else if (data['usertype'] == '14') {
          this.router.navigateByUrl('/cashier/homepage');
        } else if (data['usertype'] == '15') {
          this.router.navigateByUrl('/reporter/homepage');
        } else if (data['usertype'] == '16') {
          this.router.navigateByUrl('/Takaful/homepage');
        } else if (data['usertype'] == '17') {
          this.router.navigateByUrl('/Manager/homepage');
        } else if (data['usertype'] == '18') {
          this.router.navigateByUrl('/CLIMBS-Office/homepage');
        } 
        else{
          alert("User type not available. Contact support!");
        }

        
      },error =>{         
        this.spinner.hide();
        let err=error.error;
        let msg='';
  
        Object.keys(err).forEach(function(key){
          msg+=err[key]+'<br/>';
        })
  
        Swal.fire(
          'Oppss!',
          msg,
          'error'
        );
      });
    this.spinner.show();
  }






  



}
